import Component from './EfficiencyMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfEfficiencyMonitor', Component);
  },
};
